module.exports = __webpack_public_path__ + "static/media/SerieCVI.c608ab64.jpg";